import styled from 'styled-components';

export const ContentTableWrapper = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: 2rem;
  border-radius: 0.2rem;
  background-color: ${(props) =>
    !props.dark ? props.theme.colors.white : props.theme.colors.dark1};
  box-shadow: ${(props) => props.theme.shadows.shadow1};
  padding: 1rem 0.75rem;
  font-family: ${(props) => props.theme.fonts.karla};

  ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  li {
    margin: 0;
    padding: 0.25rem 0;
    padding-left: 0.75rem;
  }
  @media (max-width: 1024px) {
    display: none;
  }
`;

export const TableLinksWrapper = styled.div`
  a {
    text-decoration: none;

    position: relative;
    z-index: 0;
    display: inline-block;
    padding: 5px 0px;
    overflow: hidden;
    color: ${(props) =>
      props.isActive
        ? props.dark
          ? '#67bdff'
          : props.theme.colors.blue
        : props.dark
        ? 'white'
        : props.theme.colors.dark2};
    vertical-align: bottom;
    transition: color 0.3s ease-out;
  }

  a:before {
    content: '';
    position: absolute;
    width: ${(props) => (props.isActive ? '100%' : '0%')};
    height: 2px;
    bottom: 0;
    left: 0;
    background-color: ${(props) => props.theme.colors.blue};
    visibility: ${(props) => (props.isActive ? 'visible' : 'hidden')};
    transition: all 0.3s ease-in-out;
  }
`;
